import request from "@/utils/request";

export const getDeclarationElements = (params: any) =>
  request({
    url: `/declaration-elements`,
    method: "get",
    params
  });

export const deleteDeclarationElements = (id: string)=>
  request({
    url: `/declaration-elements/${id}`,
    method: "delete"
  });

export const updateDeclarationElements = (id: string, data: any) =>
  request({
    url: `/declaration-elements/${id}`,
    method: "PUT",
    data
  });

export const uploadDeclarationElementExcel = (data: FormData) =>
  request({
    headers: {"Content-Type": "multipart/form-data"},
    url: "/declaration-elements/excel",
    method: "post",
    data: data
  });

export const getAllDeclarationElements = () =>
    request({
        url: "/declaration-elements/all",
        method: "get",
    });

export const getDeclarationElementsVersion = () =>
    request({
        url: `/declaration-elements/version/customs-product-name/no-repeat`,
        method: "get",
    });
export const getTableVersionNumberIsMaxDeclarationElements = () =>
    request({
        url: `/declaration-elements/max-table-version-all`,
        method: "get",
    });